/**
 * The category filter, as squared chips with counts. "All" first; tapping the
 * chip that is already on turns it off again, which is what a thumb expects.
 */
export function CategoryChips({
  counts,
  value,
  onChange,
}: {
  counts: readonly { readonly name: string; readonly count: number }[]
  value: string | null
  onChange: (next: string | null) => void
}): JSX.Element | null {
  if (counts.length === 0) return null
  return (
    <div className="filter-row inv-chips" role="group" aria-label="Category">
      <button
        type="button"
        className={`filter-chip${value === null ? ' filter-chip--on' : ''}`}
        aria-pressed={value === null}
        onClick={() => onChange(null)}
      >
        All
      </button>
      {counts.map((c) => (
        <button
          key={c.name}
          type="button"
          className={`filter-chip${value === c.name ? ' filter-chip--on' : ''}`}
          aria-pressed={value === c.name}
          onClick={() => onChange(value === c.name ? null : c.name)}
        >
          {c.name}
          <span className="filter-chip__count">{c.count}</span>
        </button>
      ))}
    </div>
  )
}
